// Builds a reusable draft from an existing travel claim without copying
// receipts, payment evidence or completed workflow state.
(function exposeTravelCopyTemplate(global) {
  const list = (value) => Array.isArray(value) ? value : [];
  const copyMileageLine = (line, date) => ({
    date,
    fromLocation: line.fromLocation || line.from || '',
    toLocation: line.toLocation || line.to || '',
    stops: list(line.stops),
    kilometers: Number(line.kilometers ?? line.km) || 0,
    returnTrip: line.returnTrip === true || line.sameReturn === true,
    vehicle: line.vehicle || '',
    ratePerKm: Number(line.ratePerKm ?? line.rate) || undefined,
    tollAmount: 0,
    tollPaymentMethod: line.tollPaymentMethod || 'private',
    passengers: list(line.passengers),
    trailerKilometers: 0,
    forestRoadKilometers: 0,
    status: 'draft',
  });
  const copyExpenseLine = (line, date) => ({
    date,
    category: line.category || '',
    description: line.description || line.category || '',
    paymentMethod: line.paymentMethod || 'private',
    companyCardAccountId: line.companyCardAccountId || undefined,
    companyCardAccountName: line.companyCardAccountName || undefined,
    amount: 0,
    amountNet: 0,
    vatAmount: 0,
    vatRate: 0,
    currency: 'NOK',
    attachments: [],
    hasAttachment: false,
    status: 'draft',
  });
  const copyAccommodationLine = (line, date) => ({
    dateFrom: date,
    dateTo: date,
    type: line.type || line.lodgingType || 'hotel',
    lodgingType: line.lodgingType || line.type || 'Hotell',
    location: line.location || '',
    description: line.description || line.location || '',
    mealsPaidByDate: [],
    ratePerDay: 0,
    allowanceAmount: 0,
    payrollAmount: 0,
    amount: 0,
    paymentMethod: line.paymentMethod || 'private',
    status: 'draft',
  });

  const buildDraft = (travel = {}, options = {}) => {
    const date = String(options.date || new Date().toISOString().slice(0, 10));
    return {
      employeeId: travel.employeeId,
      employeeName: travel.employeeName,
      dateFrom: date,
      dateTo: date,
      destination: travel.destination || travel.country || '',
      purpose: `${String(options.purpose || travel.purpose || 'Reise').trim()} (kopi)`,
      travelType: travel.travelType || 'mixed',
      fromLocation: travel.fromLocation || '',
      toLocation: travel.toLocation || '',
      note: travel.note || undefined,
      status: 'draft',
      mileageLines: list(travel.mileageLines || travel.mileage).map((line) => copyMileageLine(line, date)),
      expenseLines: list(travel.expenseLines || travel.expenses).map((line) => copyExpenseLine(line, date)),
      accommodationLines: list(travel.accommodationLines || travel.accommodation).map((line) => copyAccommodationLine(line, date)),
      attachments: [],
      hasDiet: false,
      overnight: list(travel.accommodationLines || travel.accommodation).length > 0,
      coveredMeals: undefined,
      timeFrom: undefined,
      timeTo: undefined,
      changeLog: [],
    };
  };

  global.PlummeTravelCopyTemplate = { buildDraft };
})(window);
